import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import * as Constants from './../../helpers/constants'
import UserlistPage from '../user_list_page'
import TrialPeriods from '../trial_periods'
import DataPulseFairUsage from '../data_pulse_fair_usage'
import MiscellaneousApi from '../miscellaneous'
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info'
// import ProductList from './../products/component/list'
// import CreateProduct from './../products/component/create'
import OrganizationInfo from '../org_info/org_info'
// import Coupons from '../coupons/coupons'
import OrgListPage from '../org_list_page'
import ManageAbuse from '../abuse/manage_abuse'
import UpdateHistory from '../update_history/abuse_update_history'
import AbuseLogs from '../abuse_view_logs/abuse_view_logs'
import UserActivities from '../user_activities/user_activities'
import ServiceLists from '../service_list'
import MembersList from '../members_list/members_list'

const CLIENT = Constants.CLIENTS.PEPIPOST_CLEAROUT.NAME

const clearoutPepipostRouter = createBrowserRouter([
  {
    id: 'dashboard-pepipost-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-pepipost-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-pepipost-ev-list',
        path: 'email_verifier_lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.EMAIL_VERIFIER} />
      },
      {
        id: 'dashboard-pepipost-org-members-list',
        path: 'org_members_list',
        element: <MembersList />
      },
      {
        id: 'pepipost-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'dashboard-pepipost-org-users',
        path: 'org_list',
        element: <OrgListPage />
      },
      {
        id: 'dashboard-pepipost-user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'dashboard-pepipost-clearout-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'clearout-pepipost-organization-info',
        path: 'organization_info',
        element: <OrganizationInfo />
      },
      {
        id: 'dashboard-clearout-pepipost-manage-abuse',
        path: 'abuse_list',
        element: <ManageAbuse />
      },
      {
        id: 'dashboard-clearout-pepipost-view-logs',
        path: 'abuse_logs',
        element: <AbuseLogs />
      },
      {
        id: 'dashboard-clearout-pepipost-update-logs',
        path: 'abuse_update_logs',
        element: <UpdateHistory />
      },
      {
        id: CLIENT + '-trial-periods',
        path: 'trial_periods',
        element: <TrialPeriods />
      },
      {
        id: CLIENT + '-data-pulse-fair-usage',
        path: 'data_pulse_fair_usage',
        element: <DataPulseFairUsage />
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },

    ]
  },
])

export default clearoutPepipostRouter
